exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-4cc39d40] {\n  -webkit-mask-image: url(\"/assets/texture-mask-invert.png\");\n          mask-image: url(\"/assets/texture-mask-invert.png\");\n}\n", ""]);

// exports
